import { List } from "immutable";
import { AbstractForGrader, AbstractGraderListItem, AbstractType, ReviewerStats } from "../models/abstract";
import { ItemLoadingState } from "../models/generic";

export interface AbstractGradingState {
    abstracts: List<AbstractForGrader>;
    listAbstracts: List<AbstractGraderListItem>;
    loadingAbstract: ItemLoadingState;
    loadingListAbstracts: boolean;
    loadingType: ItemLoadingState;
    reviewerStats?: ReviewerStats;
    types: List<AbstractType>;
}

export const initialState: AbstractGradingState = {
    abstracts: List(),
    listAbstracts: List(),
    loadingAbstract: {},
    loadingListAbstracts: true,
    loadingType: {},
    types: List(),
};



// WEBPACK FOOTER //
// ./src/store/AbstractGradingState.ts